import { render, staticRenderFns } from "./BrokerOrIfaDetails.vue?vue&type=template&id=eb7cd850&"
import script from "./BrokerOrIfaDetails.vue?vue&type=script&lang=js&"
export * from "./BrokerOrIfaDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports